var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleSheets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 13,
    height: 17,
    fill: "url(#pattern0_1101_9371)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1101_9371",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1101_9371",
    transform: "matrix(0.0111111 0 0 0.00826446 -0.633333 -0.289256)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1101_9371",
    width: 204,
    height: 192,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMwAAADACAMAAAB/Pny7AAAAkFBMVEX///8BrEYAhSwAqj6c1qwAqDp2yI4ApzRRuWzV7dwAq0K94sdAsVTe8eRUuWoApS2z27m24MEBpkIApCYBoT7o9eyn2rXz+fMdrUoAoBdrwoHG588AfxwAfRLP4tPd6t8AegAAnABnv3lUq10Amy9AikBQl1dLkk1loWldnGBxpnQAnSaFy5ldvHMmslaByZDXES/OAAACgUlEQVR4nO3da4+aQBSAYUURV7Ss3SJ4a9W2u71t/f//rtOubuIEaRyOOQf3fT8OCeFJdBgNjp0OEREREREREREREREREQlUTALSvujq0sHu3eV9/qh93RXluzKOe5f35as9TdHtjbohfVjZ05RxEMVhInOa/kOgxWGi9ZMtTbDlLyZaP1rS3DXD2NLMsmYYU5p+0hBjSdMc42aBT9qKQwIYOxoJTLR6yrUd/xLBRKtHExoZjJFXmhAmWn83oJHCROtv+hoxTLTR18hhDGgEMdFG+30jiXFzWnE7GLdOU9XIYtzdU1MjjNHVSGPc3VNvZSOOcTO0mkYeE21+aGmugNHTXAOjprkKxq06Vea062DcnKahaYDpvq/p56+WYeqKB2DAgAEDBgwYMGDAgGkDZhSaPUw8SAPb+yfSx2Sz0BPdZ/Yw/dATgREOTFVghDuHmdx5Hb7UK5be+PGBYMOYfNErTxotXw5M/PFF3gJMcnp/T44Yf7wVGO+Z2vgV442DAQOmEpO0GuNNwb0DJo+98RZginTmdbjmwh9PC/OYywMjHJiqwAgHpirLmMKv858DhjH5cDs/aZu+HJj440P7K4DbXmiCAQPmDWGe5w8nzV+nZm/82T6mWE69jt9o3nvjSz6cXScwVYERDkxVBjHJLWG65TiwcmQPE/y4iXcaGxihwIABAwYMGDBgwIABAwYMGDBgwIABYwTTYO/Z2hKNDUEa7ApcW5YqYBrs11zbVsPSYCftujKNt4zrd+ge5zXFXR1LJx/HYbvPn20Uj9W2OMsXYf8LcKY4KReKf+ZQTPe7oVi7/VR3A8pO7v9eLjwTmx0TERERERERERERERHRG+0PSI14chYbBg4AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleSheets);
export default __webpack_public_path__ + "static/media/googleSheets.45b7405f.svg";
export { ForwardRef as ReactComponent };